<template>
    <div>
        <modal name="modal-edit-add-appareil" height="auto" :scrollable="true" :adaptive="true">
            <div class="p-10 overflow-y-auto max-h-[100vh]" style="z-index: 999 !important;">
                <div class="flex items-center justify-between mb-4 pb-4 border-b text-2xl">
                    <h2 class="font-bold">
                        <template v-if="selectedAppareil.id">Modifier l'appareil</template>
                        <template v-else>Ajouter un appareil</template>
                    </h2>
                    <button @click="$modal.hide('modal-edit-add-appareil');">
                        <i class="fas fa-times text-red-500"></i>
                    </button>
                </div>
                <template v-if="selectedAppareil.id && selectedAppareil.fournisseur_tel && selectedAppareil.marque == selectedAppareil.fournisseur_tel.marque">
                    <div class="bg-blue-50 p-3 border border-blue-200 rounded-md mb-4">
                        <p class="text-xs font-medium text-blue-900 mb-0.5">Contact fournisseur</p>
                        <p class="text-sm font-semibold text-blue-700"><i class="fas fa-tag mr-1"></i> {{ selectedAppareil.fournisseur_tel.marque }}</p>
                        <p class="text-sm font-semibold text-blue-700"><i class="fas fa-phone mr-1"></i> {{ selectedAppareil.fournisseur_tel.tel }}</p>
                    </div>
                </template>
                <appareil-form v-model="selectedAppareil" />
                <div class="flex justify-center mt-6">
                    <button @click="editAddAppareil" class="bg-red-600 hover:bg-red-700 text-white font-medium px-4 py-2 rounded-lg shadow transition flex items-center gap-2">
                        <i class="fas fa-check"></i> Enregistrer l'appareil
                    </button>
                </div>
            </div>
        </modal>

        <modal name="modal-edit-add-adresse" height="auto" :scrollable="true" :adaptive="true">
            <div class="p-10 overflow-y-auto max-h-[100vh]" style="z-index: 999 !important;">
                <div class="flex items-center justify-between mb-4 pb-4 border-b text-2xl">
                    <h2 class="font-bold">
                        <template v-if="adresseForm.id">Modifier l'adresse</template>
                        <template v-else>Ajouter une adresse</template>
                    </h2>
                    <button @click="$modal.hide('modal-edit-add-adresse');">
                        <i class="fas fa-times text-red-500"></i>
                    </button>
                </div>
                <adresse-form v-model="adresseForm" />
                <div class="flex justify-center mt-6">
                    <button :disabled="loadingSaveAdresse" @click="saveAdresse" class="bg-red-600 hover:bg-red-700 text-white font-medium px-4 py-2 rounded-lg shadow transition flex items-center gap-2">
                        <i v-if="loadingSaveAdresse" class="fas fa-spinner fa-spin"></i>
                        <span v-else>
                            <i class="fas fa-check"></i> Enregistrer l'adresse
                        </span>
                    </button>
                </div>
            </div>
        </modal>

        <modal name="modal-confirm-delete-client" height="auto" :scrollable="true" :adaptive="true">
            <div class="p-10 overflow-y-auto max-h-[100vh]" style="z-index: 999 !important;">
                <div class="flex items-center justify-between mb-4 pb-4 border-b text-2xl">
                    <h2 class="font-bold">
                        Confirmer la suppression du client
                    </h2>
                    <button @click="$modal.hide('modal-confirm-delete-client');">
                        <i class="fas fa-times text-red-500"></i>
                    </button>
                </div>
                <p>Êtes-vous sûr de vouloir supprimer cette fiche client ? <br />Cette action est irréversible.</p>
                <div class="flex justify-center mt-6">
                    <button @click="confirmDeleteClient" class="bg-red-600 hover:bg-red-700 text-white font-medium px-4 py-2 rounded-lg shadow transition flex items-center gap-2">
                        <i class="fas fa-check"></i> Confirmer la suppression
                    </button>
                </div>
            </div>
        </modal>

        <app-template>
            <template v-if="loadingGetData">
                <div class="bg-white border border-gray-200 rounded-xl shadow-sm">
                    <div class="flex flex-col items-center justify-center h-96">
                        <i class="fas fa-spinner fa-spin text-4xl text-slate-400 mb-4"></i>
                    </div>
                </div>
            </template>
            <div class="p-6 space-y-8" v-if="!loadingGetData">
                <!-- Header -->
                <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                    <div>
                        <h2 class="text-2xl font-bold text-gray-800">
                            <i class="fas fa-user-circle text-red-600 mr-2"></i> Fiche client
                        </h2>
                        <p class="text-sm text-gray-500 mt-1">Gérez les informations du client et son historique d'intervention.</p>
                    </div>
                    <div class="flex gap-2">
                        <button @click="$router.push({name: 'ClientList'})" class="bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium px-4 py-2 rounded-lg transition flex items-center gap-2">
                            <i class="fas fa-arrow-left"></i> Retour
                        </button>
                        <button @click="$modal.show('modal-confirm-delete-client')" class="bg-red-100 hover:bg-red-200 text-red-700 font-medium px-4 py-2 rounded-lg transition flex items-center gap-2">
                            <i class="fas fa-trash"></i> Supprimer
                        </button>
                    </div>
                </div>

                <!-- Contenu principal -->
                <div class="bg-white border border-gray-200 rounded-xl shadow-sm">
                    
                    <!-- Onglets -->
                    <div class="border-b flex overflow-x-auto">
                        <button 
                            v-for="tab in tabs" 
                            :key="tab.key"
                            @click="activeTab = tab.key"
                            :class="[
                                'px-6 py-3 text-sm font-medium flex items-center gap-2 transition border-b-2',
                                activeTab === tab.key 
                                    ? 'text-red-700 border-red-600 bg-red-50' 
                                    : 'text-gray-600 hover:text-red-700 border-transparent hover:bg-gray-50',
                                tab.key === 'infos' ? 'rounded-tl-xl' : ''
                            ]">
                            <i :class="tab.icon"></i> {{ tab.label }}
                        </button>
                    </div>

                    <!-- Contenu des onglets -->
                    <div class="p-6 space-y-10">

                        <!-- Onglet Informations -->
                        <section v-if="activeTab === 'infos'">
                            <h3 class="text-lg font-semibold mb-4 text-gray-800">
                                <i class="fas fa-info-circle text-red-600 mr-2"></i>Informations générales
                            </h3>
                            <client-form v-if="client" v-model="client" />
                            <button :disabled="loadingSaveClient" @click="saveClient" class="mt-8 bg-red-600 hover:bg-red-700 text-white font-medium px-4 py-2 rounded-lg shadow transition flex items-center gap-2">
                                <template v-if="loadingSaveClient">
                                    <i class="fas fa-spinner fa-spin"></i> Enregistrement en cours...
                                </template>
                                <template v-if="!loadingSaveClient">
                                    <i class="fas fa-save"></i> Enregistrer
                                </template> 
                            </button>
                        </section>

                        <!-- Onglet Adresses -->
                        <section v-if="activeTab === 'adresses'">
                            <h3 class="text-lg font-semibold mb-4 text-gray-800">
                                <i class="fas fa-map-marker-alt text-red-600 mr-2"></i>Adresses
                            </h3>
                            <template v-if="client && client.adresses && client.adresses.length === 0">
                                <adresse-form v-if="client" v-model="adresseForm" />
                                <button :disabled="loadingSaveAdresse" @click="saveAdresse" class="bg-red-600 hover:bg-red-700 text-white font-medium px-4 py-2 rounded-lg shadow transition flex items-center gap-2">
                                    <i v-if="loadingSaveAdresse" class="fas fa-spinner fa-spin"></i>
                                    <span v-else>
                                        <i class="fas fa-check"></i> Enregistrer l'adresse
                                    </span>
                                </button>
                            </template>
                            <template v-else>
                                <div class="overflow-hidden rounded-xl border border-gray-200 shadow-sm">
                                    <table class="w-full text-sm text-left">
                                        <thead class="bg-gray-100 text-gray-600 uppercase text-xs">
                                            <tr>
                                                <th class="px-6 py-3">Adresse 1</th>
                                                <th class="px-6 py-3">Code postal</th>
                                            <th class="px-6 py-3">Ville</th>
                                            <th class="px-6 py-3">Régie</th>
                                            <th class="px-6 py-3">Locataire</th>
                                            <th class="px-6 py-3">Action</th>
                                        </tr>
                                        </thead>
                                        <tbody class="divide-y divide-gray-100">
                                            <tr v-for="item in client.adresses" :key="'adresse-' + item.id" class="hover:bg-red-100 cursor-pointer transition" @click="adresseForm = item; $modal.show('modal-edit-add-adresse')">
                                                <td class="px-6 py-3">{{ item.adresse1 || '-' }}</td>
                                                <td class="px-6 py-3">{{ item.code_postal || '-' }}</td>
                                                <td class="px-6 py-3">{{ item.ville || '-' }}</td>
                                                <td class="px-6 py-3">{{ item.regie ? item.regie.nom : '-' }}</td>
                                                <td class="px-6 py-3">{{ item.locataire ? (item.locataire.prenom ? (item.locataire.nom + ' ' + item.locataire.prenom) : item.locataire.nom) : '-' }}</td>
                                                <td class="px-6 py-3">
                                                    <button class="text-red-600 hover:text-red-800" @click.stop="deleteAdresse(item.id)">
                                                        <i class="fas fa-trash"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="mt-4">
                                    <button @click="adresseForm = {nom_contact: client.nom, telephone: client.telephone}; $modal.show('modal-edit-add-adresse')" class="bg-red-50 hover:bg-red-100 text-red-700 font-medium px-4 py-2 rounded-lg border border-red-200 transition flex items-center gap-2">
                                        <i class="fas fa-plus"></i> Ajouter une adresse
                                    </button>
                                </div>
                            </template>
                        </section>

                        <!-- Onglet appareils -->
                        <section v-if="activeTab === 'appareils'">
                            <template v-if="client.appareils && client.appareils.length === 0">
                                <appareil-form v-model="selectedAppareil" />
                                <div class="flex justify-center mt-6">
                                    <button @click="editAddAppareil" class="bg-red-600 hover:bg-red-700 text-white font-medium px-4 py-2 rounded-lg shadow transition flex items-center gap-2">
                                        <i class="fas fa-check"></i> Enregistrer l'appareil
                                    </button>
                                </div>
                            </template>

                            <template v-if="client.appareils && client.appareils.length > 0">
                                <h3 class="text-lg font-semibold mb-4 text-gray-800">
                                    <i class="fas fa-tools text-red-600 mr-2"></i>Appareils installés
                                </h3>
                                <div class="overflow-hidden rounded-xl border border-gray-200 shadow-sm">
                                    <table class="w-full text-sm text-left">
                                        <thead class="bg-gray-100 text-gray-600 uppercase text-xs">
                                            <tr>
                                                <th class="px-6 py-3">Type</th>
                                                <th class="px-6 py-3">Marque</th>
                                                <th class="px-6 py-3">Modèle</th>
                                                <th class="px-6 py-3">N° série</th>
                                                <th class="px-6 py-3">Date d'installation</th>
                                            </tr>
                                        </thead>
                                        <tbody class="divide-y divide-gray-100">
                                            <tr v-for="item in client.appareils" :key="'appareil-' + item.id" class="hover:bg-red-100 cursor-pointer transition" @click="selectedAppareil = item; $modal.show('modal-edit-add-appareil')">
                                                <td class="px-6 py-3">{{ item?.app_type?.label || '-' }}</td>
                                                <td class="px-6 py-3">{{ item.marque || '-' }}</td>
                                                <td class="px-6 py-3">{{ item.model || '-' }}</td>
                                                <td class="px-6 py-3">{{ item.numero_serie || '-' }}</td>
                                                <td class="px-6 py-3">{{ item.installation_date | momentDate}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div class="mt-4">
                                    <button @click="selectedAppareil = {}; $modal.show('modal-edit-add-appareil')" class="bg-red-50 hover:bg-red-100 text-red-700 font-medium px-4 py-2 rounded-lg border border-red-200 transition flex items-center gap-2">
                                        <i class="fas fa-plus"></i> Ajouter un appareil
                                    </button>
                                </div>
                            </template>
                        </section>

                        <!-- Onglet Chantiers -->
                        <section v-if="activeTab === 'chantiers'">
                            <h3 class="text-lg font-semibold mb-4 text-gray-800">
                                <i class="fas fa-calendar-check text-red-600 mr-2"></i>Historique des chantiers
                            </h3>

                            <client-chantier-list :client-id="client.id" />
                        </section>

                        <!-- Facturation -->
                        <section v-if="activeTab === 'factures'">
                            <h3 class="text-lg font-semibold mb-4 text-gray-800">
                                <i class="fas fa-file-invoice text-red-600 mr-2"></i>Facturation
                            </h3>

                            <client-facture-list :client-id="client.id" />
                        </section>

                        <!-- Onglet Notes -->
                        <section v-if="activeTab === 'notes'">
                            <h3 class="text-lg font-semibold mb-4 text-gray-800">
                                <i class="fas fa-file-alt text-red-600 mr-2"></i>Notes et documents
                            </h3>

                            <client-notes-view :client-id="client.id" />
                        </section>

                        <!-- Portail client -->
                        <section v-if="activeTab === 'portail'">
                            <h3 class="text-lg font-semibold mb-4 text-gray-800">
                                <i class="fas fa-globe text-red-600 mr-2"></i>Portail client
                            </h3>
                            <div class="grid grid-cols-2 gap-4">
                                <div class="bg-gradient-to-br from-red-50 to-orange-50 border border-red-200 rounded-xl p-6 shadow-sm">
                                    <div class="flex items-start gap-4">
                                        <div class="flex-1">
                                            <h4 class="text-lg font-semibold text-gray-800 mb-2">Accès au portail client</h4>
                                            <p class="text-sm text-gray-600 mb-4">Votre client peut consulter ses interventions, factures et documents via son portail personnalisé.</p>
                                            <a :href="`/c/${client.token}`" target="_blank" class="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-medium px-4 py-2 rounded-lg shadow transition">
                                                <i class="fas fa-external-link-alt"></i>
                                                Ouvrir le portail du client
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <!-- Carte pour envoyer le lien par email -->
                                <div>
                                    <div class="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
                                        <h4 class="text-lg font-semibold text-gray-800 mb-2">Envoyer le lien par email</h4>
                                        <p class="text-sm text-gray-600 mb-4">Envoyez un email contenant le lien d'accès au portail client.</p>
                                        <button :disabled="loadingSendPortalMail" @click="sendPortailMail" class="inline-flex items-center gap-2 bg-red-50 hover:bg-red-100 text-red-700 font-medium px-4 py-2 rounded-lg border border-red-200 transition">
                                            <template v-if="loadingSendPortalMail">
                                                <i class="fas fa-spinner fa-spin"></i> Envoi en cours...
                                            </template>
                                            <template v-if="!loadingSendPortalMail">
                                                <i class="fas fa-envelope"></i> Envoyer l'email
                                            </template>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </app-template>
    </div>
</template>

<script>
import moment from 'moment';

import ClientForm from './Components/ClientForm.vue';
import AppareilForm from './Components/AppareilForm.vue';
import AdresseForm from './Components/AdresseForm.vue';
import ClientFactureList from './Components/ClientFactureList.vue';
import ClientChantierList from './Components/ClientChantierList.vue';
import ClientNotesView from './Components/ClientNotesView.vue';

export default {
    name: 'ClientView',
    components: {
        ClientForm,
        AppareilForm,
        AdresseForm,
        ClientFactureList,
        ClientChantierList,
        ClientNotesView
    },
    data() {
        return {
            client: {
                nom: '',
                prenom: '',
                email: '',
                telephone: '',
                adresse1: '',
                adresse2: '',
                ville: '',
                code_postal: '',
                pays: '',
                type_client: '',
                siret: ''
            },
            activeTab: 'infos',
            tabs: [
                { key: 'infos', label: 'Général', icon: 'fas fa-id-card' },
                { key: 'adresses', label: 'Adresses', icon: 'fas fa-map-marker-alt' },
                { key: 'appareils', label: 'Appareils', icon: 'fas fa-toolbox' },
                { key: 'chantiers', label: 'Chantiers', icon: 'fas fa-helmet-safety' },
                { key: 'factures', label: 'Facturation', icon: 'fas fa-file-invoice' },
                { key: 'notes', label: 'Notes', icon: 'fas fa-file-alt' }
            ],
            adresseForm: {},

            selectedAppareil: {},

            loadingSaveClient: false,
            loadingGetData: false,
            loadingSaveAdresse: false,
            loadingSendPortalMail: false
        }
    },
    filters: {
        momentDate(date) {
            if (date) {
                return moment(date).format('DD/MM/YYYY')
            }
            return '-'
        },
        momentDateTime(date) {
            if (date) {
                return moment(date).format('DD/MM/YYYY HH:mm')
            }
            return '-'
        }
    },
    methods: {
        async getClient() {
            const id = this.$route.params.id
            try {
                this.loadingGetData = true
                this.client = await this.$request.get(`/clients/${id}`)
                this.loadingGetData = false

                if (this.client.adresses && this.client.adresses.length <= 0) {
                    this.adresseForm = {
                        nom_contact: this.client.nom,
                        telephone: this.client.telephone
                    }
                }
            } catch (e) {
                this.$toast.error('Impossible de charger le client.')
            }
        },
        async saveClient() {
            const id   = this.$route.params.id
            const type = this.client.type_client || 'particulier'

            const rules = type === 'professionnel'
                ? [
                    'proprietaire-nom:required|min=2',
                    'proprietaire-siret:required|siret',
                ]
                : [
                    'proprietaire-nom:required|min=2',
                    'proprietaire-email:required|email',
                    'proprietaire-telephone:required|tel',
                ]

            const validation = this.$inpError(rules)
            if (!validation) {
                this.$toast.error('Formulaire invalide')
                return
            }
            try {
                this.loadingSaveClient = true
                await this.$request.post(`/clients/${id}`, this.client)
                this.$toast.success('Client mis à jour')
            } catch (e) {
                this.$toast.error('Erreur lors de la mise à jour du client')
            } finally {
                this.loadingSaveClient = false
            }
        },

        async editAddAppareil() {
            const validation = this.$inpError([
                'inp-type:required|min=3',
                'inp-marque:required|min=2',
                'inp-modele:required|min=2',
                'inp-numero_serie:nullable|min=3'
            ]);

            if (!validation) {
                this.$toast.error('Formulaire invalide')
                return
            }

            try {
                let url = this.selectedAppareil.id ? `/client-appareils/${this.selectedAppareil.id}` : '/client-appareils';
                this.selectedAppareil.client_id = this.client.id;
                await this.$request.post(url, this.selectedAppareil);
                await this.getClient();
                this.$toast.success('Appareil ajouté');
                this.$modal.hide('modal-edit-add-appareil');
                this.selectedAppareil = {};
            } catch (e) {
                this.$toast.error("Erreur lors de l'enregistrement de l'appareil");
            }
        },

        async confirmDeleteClient() {
            const id = this.$route.params.id
            let response = await this.$request.post(`/clients/${id}/delete`)
            if (response) {
                this.$toast.success('Client supprimé')
                this.$router.push({ name: 'ClientList' })
            } else {
                this.$toast.error('Erreur lors de la suppression du client')
            }
        },

        async saveAdresse() {
            this.loadingSaveAdresse = true
            try {
                const { regie, locataire, ...adressePayload } = this.adresseForm

                const hasRegie     = !!(regie && regie.nom)
                const hasLocataire = !!(locataire && (locataire.nom || locataire.prenom || locataire.email || locataire.telephone))

                const proprietaireType = this.client.type_client || 'particulier'
                const regieType        = regie?.type_client      || 'particulier'
                const locataireType    = locataire?.type_client  || 'particulier'

                const rules = []

                // Propriétaire
                if (hasRegie) {
                    rules.push('proprietaire-nom:required|min=2')
                } else if (proprietaireType === 'professionnel') {
                    rules.push(
                        'proprietaire-nom:required|min=2',
                        'proprietaire-siret:required|siret',
                    )
                } else {
                    rules.push(
                        'proprietaire-nom:required|min=2',
                        'proprietaire-email:required|email',
                        'proprietaire-telephone:required|tel',
                    )
                }

                // Régie
                if (hasRegie) {
                    if (regieType === 'professionnel') {
                        rules.push(
                            'regie-nom:required|min=2',
                            'regie-siret:required|siret',
                        )
                    } else {
                        rules.push(
                            'regie-nom:required|min=2',
                            'regie-email:required|email',
                            'regie-telephone:required|tel',
                        )
                    }
                }

                // Locataire (si des champs sont remplis et que c'est un pro, on valide le siret)
                if (hasLocataire && locataireType === 'professionnel') {
                    rules.push(
                        'locataire-nom:required|min=2',
                        'locataire-siret:required|siret',
                    )
                }

                const validation = this.$inpError(rules)
                if (!validation) {
                    this.$toast.error('Formulaire invalide')
                    this.loadingSaveAdresse = false
                    return
                }

                // Locataire : bloc ouvert mais aucun champ rempli
                if (locataire && !hasLocataire) {
                    this.$toast.error('Veuillez remplir au moins un champ pour le locataire')
                    this.loadingSaveAdresse = false
                    return
                }

                // ── Sauvegarde ──────────────────────────────────────────────
                let regieId     = adressePayload.regie_id     || 0
                let locataireId = adressePayload.locataire_id || 0

                if (regie?.nom && !regie.id) {
                    const res = await this.$request.post('/clients', {
                        ...regie,
                        type: 'regie', regie_id: 0, proprietaire_id: 0,
                    })
                    regieId = res.client.id
                } else if (regie?.id) {
                    await this.$request.post(`/clients/${regie.id}`, regie)
                    regieId = regie.id
                }

                if (locataire?.nom && !locataire.id) {
                    const res = await this.$request.post('/clients', {
                        ...locataire,
                        type: 'locataire', regie_id: regieId,
                        proprietaire_id: this.$route.params.id,
                    })
                    locataireId = res.client.id
                } else if (locataire?.id) {
                    await this.$request.post(`/clients/${locataire.id}`, locataire)
                    locataireId = locataire.id
                }

                const url = adressePayload.id
                    ? `/client-adresses/${adressePayload.id}`
                    : `/clients/${this.$route.params.id}/adresses`

                await this.$request.post(url, {
                    ...adressePayload,
                    client_id: this.$route.params.id,
                    regie_id: regieId,
                    locataire_id: locataireId,
                })

                this.adresseForm = {}
                await this.getClient()
                this.$modal.hide('modal-edit-add-adresse')
            } catch (e) {
                console.error(e)
                this.$toast.error("Erreur lors de l'enregistrement de l'adresse")
            } finally {
                this.loadingSaveAdresse = false
            }
        },

        async deleteAdresse(adresseId) {
            if (confirm('Êtes-vous sûr de vouloir supprimer cette adresse ?')) {
                try {
                    await this.$request.post(`/client-adresses/${adresseId}/delete`)
                    this.$toast.success('Adresse supprimée')
                    await this.getClient()
                } catch (e) {
                    this.$toast.error('Erreur lors de la suppression de l\'adresse')
                }
            }
        },

        async sendPortailMail() {
            try {
                this.loadingSendPortalMail = true
                await this.$request.post(`/clients/send-portail-mail`, { client_id: this.client.id })
                this.$toast.success('Email envoyé au client')
            } catch (e) {
                this.$toast.error('Erreur lors de l\'envoi de l\'email')
            } finally {
                this.loadingSendPortalMail = false
            }
        }
    },
    async mounted() {
        this.getClient()

        if (this.$account.account.societe.has_portail) {
            this.tabs.push(
                { key: 'portail', label: 'Portail client', icon: 'fas fa-globe' }
            )
        }
    },
}
</script>